import { forwardRef, Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ApplicationExceptionHandler } from '@project-management-system/backend-utils';
import { GrnFabricEntity } from './entities/grn-fabric-entity';
import { GrnController } from './grn.controller';
import { GrnTrimsEntity } from './entities/grn-trims.entity';
import { GrnRepository } from './dto/grn-repository';
import { GrnEntity } from './entities/grn-entity';
import { GrnService } from './grn.service';
import { GrnAdapter } from './dto/grn-adapter';
import { GrnItemsEntity } from './entities/grn-items-entity';
import { PurchaseOrderFbricEntity } from '../purchase-order/entities/purchase-order-fabric-entity';
import { PurchaseOrderTrimEntity } from '../purchase-order/entities/purchase-order-trim-entity';
import { PurchaseOrderEntity } from '../purchase-order/entities/purchase-order-entity';
import { IndentRepository } from '../indent/dto/indent-repository';
import { Indent } from '../indent/indent-entity';
import { FabricIndentRepository } from '../indent/dto/fabric-indent-repository';
import { IndentFabricEntity } from '../indent/indent-fabric-entity';
import { TrimIndentRepository } from '../indent/dto/trim-indent-repository';
import { IndentTrimsEntity } from '../indent/indent-trims-entity';
import { PurchaseOrderItemsEntity } from '../purchase-order/entities/purchase-order-items-entity';
import { SampleRequest } from '../sample-dev-request/entities/sample-dev-request.entity';
import { IndentService } from '../indent/indent.service';
import { PurchaseOrderRepository } from '../purchase-order/repo/purchase-order-repository';
import { ColourService } from '../colours/colour.service';
import { BuyerDestinationService, UomService } from '@project-management-system/shared-services';
import { IndentAdapter } from '../indent/dto/indent-adapter';
import { Colour } from '../colours/colour.entity';
import { ColourAdapter } from '../colours/dto/colour-adapter';
import { M3TrimsCategoryMappingRepo } from '../m3-trims/m3-trims-category-mapping.repo';
import { CategoryMappingEntity } from '../m3-trims/m3-trims-category-mapping.entity';
import { RollWiseStockEntity } from './entities/roll-wise-stock-entity';
import { RollWiseStockRepository } from './dto/roll-wise-stock-repository';
import { EmployeeDetailsRepo } from '../employee-details/dto/employee-detail-repository';
import { EmplyeeDetails } from '../employee-details/dto/employee-details-entity';
import { EmployeeBuyerMappingService } from '../employee-buyer-mapping/employee-buyer-mapping.service';
import { EmployeeBuyerMappingRepository } from '../employee-buyer-mapping/employee-buyer-mapping.repo';
import { EmployeeBuyerMapping } from '../employee-buyer-mapping/employee-buyer-mapping.entity';
import { BuyersModule } from '../buyers/buyers.module';

@Module({
    imports: [
        TypeOrmModule.forFeature([GrnEntity,GrnFabricEntity,GrnTrimsEntity,GrnItemsEntity,PurchaseOrderFbricEntity,PurchaseOrderTrimEntity,PurchaseOrderEntity,Indent,IndentFabricEntity,IndentTrimsEntity,PurchaseOrderItemsEntity,SampleRequest,Colour,CategoryMappingEntity,RollWiseStockEntity,EmplyeeDetails,EmployeeBuyerMapping]),BuyersModule,
      ],
      providers: [ApplicationExceptionHandler,GrnRepository,GrnService,GrnAdapter,IndentRepository,FabricIndentRepository,TrimIndentRepository,IndentService,PurchaseOrderRepository,ColourService,UomService,IndentAdapter,ColourAdapter,BuyerDestinationService,M3TrimsCategoryMappingRepo,RollWiseStockRepository,EmployeeDetailsRepo,EmployeeBuyerMappingService,EmployeeBuyerMappingRepository],
      controllers: [GrnController],
      exports: []
})
export class GrnModule { }